<template>
  <CommonFramework :name="title">
    <div v-html="text"></div>
  </CommonFramework>
</template>

<script>
  import CommonFramework from "@components/commonFramework/index";
  import {http} from '@utils';

  export default {
    name: "serviceAgreement",
    components: {CommonFramework},
    data(){
      return {
        type: 1, // type 1代表服务协议 2代表隐私协议
        title: '',
        text: ''
      }
    },
    async mounted() {
      const type = this.$route.query.type
      this.agreement = await this.getAgreement(type)
    },
    methods: {
      async getAgreement(t) {
        const res = await http.get('//cms.haiziwang.com/publish/976/popagreement.json');
        const _d = res.data
        if (t*1 === 1) {
          this.title = _d.serviceTitle
          this.text = _d.serviceText
        } else {
          this.title = _d.privacyTitle
          this.text = _d.privacyText
        }
      }
    }
  }
</script>

<style scoped>

</style>
